import React, {useEffect} from 'react'
import './transhiscard.style.css'


function TransHisCard({ data, onSelect }) {

    let orderList = data && String(data.packages_name).split(",")

    useEffect(() => {
        
    }, [])

    return (
        <div 
            className="transhis-item"
            onClick={() => onSelect(data && data.id)}
        >
            {/* top (date & status) */}
            <div className="tsh-item-date">
                <span className={data && String(data.strstatus).replaceAll(' ', '') === 'ชำระเงินสำเร็จ' ? 'left green' : 'left gray'}>{data && data.strstatus}</span>
                <span 
                    className="right"
                >
                    <span className='tsh-date-right'>{data && String(data.appointmentDate).split(' ')[0]} <i className="bi bi-chevron-right"></i></span>
                </span>
            </div>
            {/* order number */}
            <p className="order-number">หมายเลขคำสั่งซื้อ: {data && data.refNo}</p>
            {/* text (รายการ) */}
            <p className="list">รายการ</p>
            {/* product list */}
            {orderList && orderList.map((od, i) => 
                <p className="product-list" key={i} >{od}</p>
            )}
            {/* total price */}
            <div className="total-price">
                <span>ราคารวมทั้งหมด</span>
                <h4>{Number(data && data.netPrice).toLocaleString('th', {minimumFractionDigits: 2})}</h4>
            </div>
        </div>
    )
}

export default TransHisCard